import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { get } from '../controllers/apiController';

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({});
    const [loaded, setLoaded] = useState(false);

    const loadSettings = useCallback(async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) return;
            const r = await get('settings');
            setSettings(r?.settings || {});
        } catch {
            // ayarlar yüklenemese de uygulama çalışmaya devam eder
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => { loadSettings(); }, [loadSettings]);

    // Anında yerel state güncelleme + sunucu yenileme
    const applySettings = useCallback((newSettingsPartial) => {
        setSettings(prev => ({ ...prev, ...newSettingsPartial }));
    }, []);

    const isModuleActive = useCallback((moduleName) => {
        const mod = settings[`modul_${moduleName}`];
        if (!mod) return false;
        if (typeof mod === 'object') return mod.aktif === true || mod.aktif === 'true';
        return mod === 'true' || mod === true;
    }, [settings]);

    // Feature flags - varsayılan olarak tüm özellikler açık
    const isFeatureEnabled = useCallback((featureKey) => {
        const flags = settings.feature_flags;
        if (!flags || typeof flags !== 'object') return true;
        if (flags[featureKey] === undefined) return true;
        return flags[featureKey] === true || flags[featureKey] === 'true';
    }, [settings]);

    return (
        <SettingsContext.Provider value={{ settings, loaded, isModuleActive, isFeatureEnabled, refreshSettings: loadSettings, applySettings }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
